import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const CpRequestItemStyled = {
  Wrapper: styled.div`
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.COLORS.BORDER};
    max-height: 500px;
    overflow-y: auto;
  `,
  ItemWrapper: styled.li`
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.BORDER};
    width: 100%;
    ${FLEX.FlexStartStart};
    flex-direction: column;
    padding: 10px 0;
  `,
  Info: styled.ul`
    width: 100%;
    display: grid;
    grid-template-columns: 110px 120px 60px auto;
    column-gap: 24px;
    row-gap: 8px;
    padding-bottom: 10px;
    color: ${({ theme }) => theme.COLORS.WHITE};

    > li {
      display: contents;
      font-size: ${calcRem(14)};
    }

    .label {
      color: ${({ theme }) => theme.COLORS.BUTTONS3};
      font-weight: 500;
      white-space: nowrap;
      text-align: left;
    }

    .value {
      word-break: break-all;
      white-space: pre-wrap;
      overflow-wrap: anywhere;
      min-width: 0;
    }

    .message {
      .label {
        grid-column: 1 / 2;
      }
      .value {
        grid-column: 2 / 5;
      }
    }

    ${mediaQuery.isMobile} {
      grid-template-columns: max-content 1fr;
      .message .value {
        grid-column: 2 / 3;
      }
    }
  `,
  ButtonWrapper: styled.div`
    width: 100%;
    ${FLEX.FlexEndCenter};
    gap: 10px;
  `,
};
